"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraitHelpers = void 0;
var TraitLong_1 = require("./TraitLong");
var TraitDouble_1 = require("./TraitDouble");
var TraitInt_1 = require("./TraitInt");
var TraitString_1 = require("./TraitString");
var TraitDatetime_1 = require("./TraitDatetime");
var TraitBoolean_1 = require("./TraitBoolean");
var TraitHelpers = (function () {
    function TraitHelpers() {
    }
    TraitHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        var fullClassName = o.getFullClassName();
        return TraitInt_1.TraitIntStruct.isRegisteredType(fullClassName) || TraitLong_1.TraitLongStruct.isRegisteredType(fullClassName) || TraitDouble_1.TraitDoubleStruct.isRegisteredType(fullClassName) || TraitString_1.TraitStringStruct.isRegisteredType(fullClassName) || TraitBoolean_1.TraitBooleanStruct.isRegisteredType(fullClassName) || TraitDatetime_1.TraitDatetimeStruct.isRegisteredType(fullClassName);
    };
    TraitHelpers.serialize = function (adt) {
        var _a, _b, _c, _d, _e, _f, _g;
        var className = adt.getClassName();
        var fullClassName = adt.getFullClassName();
        var serialized = undefined;
        if (TraitInt_1.TraitIntStruct.isRegisteredType(fullClassName)) {
            className = 'TraitInt';
            serialized = (_a = {}, _a[fullClassName] = adt.serialize(), _a);
        }
        else if (TraitLong_1.TraitLongStruct.isRegisteredType(fullClassName)) {
            className = 'TraitLong';
            serialized = (_b = {}, _b[fullClassName] = adt.serialize(), _b);
        }
        else if (TraitDouble_1.TraitDoubleStruct.isRegisteredType(fullClassName)) {
            className = 'TraitDouble';
            serialized = (_c = {}, _c[fullClassName] = adt.serialize(), _c);
        }
        else if (TraitString_1.TraitStringStruct.isRegisteredType(fullClassName)) {
            className = 'TraitString';
            serialized = (_d = {}, _d[fullClassName] = adt.serialize(), _d);
        }
        else if (TraitBoolean_1.TraitBooleanStruct.isRegisteredType(fullClassName)) {
            className = 'TraitBoolean';
            serialized = (_e = {}, _e[fullClassName] = adt.serialize(), _e);
        }
        else if (TraitDatetime_1.TraitDatetimeStruct.isRegisteredType(fullClassName)) {
            className = 'TraitDatetime';
            serialized = (_f = {}, _f[fullClassName] = adt.serialize(), _f);
        }
        if (className == 'TraitInt') {
            className = 'ti';
        }
        if (className == 'TraitLong') {
            className = 'tl';
        }
        if (className == 'TraitDouble') {
            className = 'td';
        }
        if (className == 'TraitString') {
            className = 'ts';
        }
        if (className == 'TraitBoolean') {
            className = 'tb';
        }
        if (className == 'TraitDatetime') {
            className = 'tt';
        }
        return _g = {},
            _g[className] = serialized || adt.serialize(),
            _g;
    };
    TraitHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'ti': return TraitInt_1.TraitIntStruct.create(content);
            case 'tl': return TraitLong_1.TraitLongStruct.create(content);
            case 'td': return TraitDouble_1.TraitDoubleStruct.create(content);
            case 'ts': return TraitString_1.TraitStringStruct.create(content);
            case 'tb': return TraitBoolean_1.TraitBooleanStruct.create(content);
            case 'tt': return TraitDatetime_1.TraitDatetimeStruct.create(content);
            default:
                throw new Error('Unknown type id ' + id + ' for Trait');
        }
    };
    return TraitHelpers;
}());
exports.TraitHelpers = TraitHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.services.common.traits.Trait', {
    full: 'net.playq.services.common.traits.Trait',
    short: 'Trait',
    package: 'net.playq.services.common.traits',
    type: irt_1.IntrospectorTypes.Adt,
    options: [
        {
            name: 'ti',
            type: { intro: irt_1.IntrospectorTypes.Mixin, full: 'net.playq.services.common.traits.TraitInt' }
        },
        {
            name: 'tl',
            type: { intro: irt_1.IntrospectorTypes.Mixin, full: 'net.playq.services.common.traits.TraitLong' }
        },
        {
            name: 'td',
            type: { intro: irt_1.IntrospectorTypes.Mixin, full: 'net.playq.services.common.traits.TraitDouble' }
        },
        {
            name: 'ts',
            type: { intro: irt_1.IntrospectorTypes.Mixin, full: 'net.playq.services.common.traits.TraitString' }
        },
        {
            name: 'tb',
            type: { intro: irt_1.IntrospectorTypes.Mixin, full: 'net.playq.services.common.traits.TraitBoolean' }
        },
        {
            name: 'tt',
            type: { intro: irt_1.IntrospectorTypes.Mixin, full: 'net.playq.services.common.traits.TraitDatetime' }
        }
    ]
});
//# sourceMappingURL=Trait.js.map